import { render, staticRenderFns } from "./FeedbackButton.vue?vue&type=template&id=f7ca9534&"
import script from "./FeedbackButton.vue?vue&type=script&lang=js&"
export * from "./FeedbackButton.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackButton.vue?vue&type=style&index=0&id=f7ca9534&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports